var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 bg-light min-vh-100"},[(_vm.loaded)?_c('kontragent-form',{attrs:{"datas":_vm.dataall}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }